import React, { ComponentType, useState } from "react";
import { TextAutoComplete } from "App/Atomics/AutoComplete";
import { findGenreList } from "./findGenreList";
import { Info } from "App/Atomics/AutoComplete/TextAutoComplete";
import styled from "styled-components";
import { GRAY_5 } from "constants/baseColor";
import { PRIMARY_COLOR_LIGHT } from "constants/color";
import { components, OptionProps } from "react-select";

type Props = Pick<
  Parameters<typeof TextAutoComplete>[0],
  "style" | "className" | "classNamePrefix" | "isDisabled" | "isClearable" | "defaultValue" | "defaultOptions" | "onChange" | "onBlur"
> &
  Readonly<{
    /**
     * | 값 | 의미 |
     * | - | - |
     * | undefined | 대분류/소분류 |
     * | true | 대분류 |
     * | false | 소분류 |
     */
    isParent?: boolean;
  }>;

export const GenreTextAutoComplete = ({
  style,
  className,
  classNamePrefix,
  isDisabled,
  defaultValue,
  defaultOptions,
  onChange,
  onBlur,
  isParent,
  isClearable
}: Props) => {
  const [initialOptions, setInitialOptions] = useState<Info[] | undefined>(defaultOptions);

  const onFocus = async () => {
    const info = await findGenreList({ keyword: "", isParent });
    setInitialOptions(info);
  };
  return (
    <TextAutoComplete
      placeholder="장르를 입력해주세요."
      isDisabled={isDisabled}
      defaultValue={defaultValue}
      defaultOptions={initialOptions}
      delay={200}
      style={style}
      className={className}
      classNamePrefix={classNamePrefix}
      onFocus={onFocus}
      onChange={onChange}
      onBlur={onBlur}
      loadInfoList={keyword => findGenreList({ keyword, isParent })}
      isClearable={isClearable}
      components={{ Option }}
    />
  );
};

const Option: ComponentType<OptionProps<any>> = ({ children, ...props }) => {
  return (
    <components.Option {...props}>
      <OptionWrapper>
        <span className="id">{props.data.id}</span>
        <span className="name">{props.data.name}</span>
        <span className="extra">{props.data.parent}</span>
      </OptionWrapper>
    </components.Option>
  );
};

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  .id {
    font-size: 9px;
    color: ${GRAY_5};
  }
  .name {
    font-size: 13px;
    font-weight: 500;
  }
  .extra {
    font-size: 10px;
    font-weight: 400;
    color: ${PRIMARY_COLOR_LIGHT};
  }
`;
